var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M40.25 10.0625L23 25.875L5.75 10.0625H40.25Z",
    fill: "#9CA37F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.75 10.0625H40.25V34.5C40.25 34.8812 40.0986 35.2469 39.829 35.5165C39.5594 35.7861 39.1937 35.9375 38.8125 35.9375H7.1875C6.80625 35.9375 6.44062 35.7861 6.17103 35.5165C5.90145 35.2469 5.75 34.8812 5.75 34.5V10.0625Z",
    stroke: "#9CA37F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.25 10.0625L23 25.875L5.75 10.0625",
    stroke: "#9CA37F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.3b38f788c2b042fdae4cc36287533f35.svg";
export { ForwardRef as ReactComponent };